import React from "react";

import { InputPicker } from "rsuite";

const VisitForm = ({
    requiredVisitTimerData,
    requiredMinutes,
    visitSoonTimerOptionsData,
    soonMinutes,
    handleChange,
    handleResetDefaultVisits }) => {

    return (<div className="col-md-6">
        <div className="card">
            <div className="card-header">
                Visit Tracker
            </div>

            <div className="card-body px-0 py-0 bed-exit">
                <section>
                    <div className="row">
                        <div className="col-md-8">
                            <label>
                                <div>
                                    Required Visit Timer
                                    <small>
                                        This room <strong>must be visited</strong> every:
                                    </small>
                                </div>
                            </label>
                        </div>
                        <div className="col-md-4">
                            <InputPicker data={requiredVisitTimerData}
                                className="settings-group"
                                placeholder={"Select visit Timer"}
                                onChange={(value) => handleChange("setting.visit.require_visit", value)}
                                value={requiredMinutes} />
                        </div>
                    </div>
                </section>

                <section>
                    <div className="row">
                        <div className="col-md-8">
                            <label>
                                <div>
                                    Visit Soon Timer
                                    <small>
                                        Choose the amount of minutes before the Required Visit that the <strong>Visit Soon alert</strong> will be triggered.
                                    </small>
                                </div>
                            </label>
                        </div>
                        <div className="col-md-4">

                            <InputPicker data={visitSoonTimerOptionsData}
                                placeholder={"Select visit Timer"}
                                className="settings-group"
                                onChange={(value) => handleChange("setting.visit.visit_soon", value)}
                                value={soonMinutes} />
                        </div>
                    </div>
                </section>
            </div>

            <div className="card-footer text-right">
                <button className="btn btn-secondary" onClick={handleResetDefaultVisits}>Return to Default</button>
            </div>
        </div>
    </div>);
}

VisitForm.defaultProps = {
    requiredVisitTimerData: null,
    requiredMinutes: null,
    visitSoonTimerOptionsData: null,
    soonMinutes: null,
}

export default VisitForm;